// extracted by mini-css-extract-plugin
export var address = "practitionerCard-module--address--36b96";
export var blackBg = "practitionerCard-module--blackBg--b5e5b";
export var category = "practitionerCard-module--category--c60c5";
export var phone = "practitionerCard-module--phone--c47a3";
export var visible = "practitionerCard-module--visible--cf23d";
export var wrapper = "practitionerCard-module--wrapper--dd285";